type Id = string | number;

type TagDescription<TagType extends string> =
  | TagType
  | { type: TagType; id?: Id };

type TagArray<TagType extends string> =
  readonly (TagDescription<TagType> | null | undefined)[];

type TagsGetter<TagType extends string, TResult, TError, TArg> =
  | TagArray<TagType>
  | ((
      result: TResult | undefined,
      error: TError | undefined,
      arg: TArg,
    ) => TagArray<TagType>);

export function safeInvalidateTags<
  TagType extends string,
  TResult = unknown,
  TError = unknown,
  TArg = unknown,
>(
  getTags: TagsGetter<TagType, TResult, TError, TArg>,
): (
  result: TResult | undefined,
  error: TError | undefined,
  arg: TArg,
) => TagArray<TagType> {
  const normalizedGetTags =
    typeof getTags === "function"
      ? getTags
      : () => getTags;

  return (result, error, arg) => {
    if (error) {
      return [] as TagArray<TagType>;
    }
    return normalizedGetTags(result, error, arg);
  };
}
